import { Entity, Field } from 'typegraph';
import GroupDiscountData from './GroupDiscountData';

@Entity({one: "groupPurchaseService", many: "groupPurchaseServices"})
export default class GroupDiscount {

    @Field({ entity: GroupDiscountData })
	public data: GroupDiscountData[];
}



// WEBPACK FOOTER //
// ./src/panels/bundleEntries/entities/GroupDiscount.ts